import { 
  Building, 
  Fuel, 
  Droplet, 
  BarChart, 
  ClipboardList,
  FolderTree,
  Users,
  UserCog,
  LayoutDashboard
} from 'lucide-react';
import { ADMIN_ROLES, LIMITED_ROLES } from '@/utils/roles';

export const MENU_SIDEBAR = [
  {
    title: 'Dashboard',
    icon: LayoutDashboard,
    path: '/dashboard',
    roles: ADMIN_ROLES,
  },
  {
    title: 'Relatórios',
    icon: BarChart,
    roles: ADMIN_ROLES,
    children: [
      {
        title: 'Semanal',
        icon: BarChart,
        path: '/admin/relatorios-semanais',
        roles: ADMIN_ROLES,
      },
      {
        title: 'Mensal',
        icon: BarChart,
        path: '/relatorio',
        roles: ADMIN_ROLES,
      },
    ],
  },
  {
    title: 'Relatório Mensal',
    icon: BarChart,
    path: '/relatorio',
    roles: LIMITED_ROLES,
  },
  {
    title: 'Aferições',
    icon: ClipboardList,
    path: '/admin/afericoes',
    roles: ADMIN_ROLES,
  },
  {
    title: 'Cadastros',
    icon: FolderTree,
    roles: ADMIN_ROLES,
    children: [
      {
        title: 'Empresas',
        icon: Building,
        path: '/admin/empresas',
        roles: ADMIN_ROLES,
      },
      {
        title: 'Bicos',
        icon: Fuel,
        path: '/admin/bicos',
        roles: ADMIN_ROLES,
      },
      {
        title: 'Tipos de Combustível',
        icon: Droplet,
        path: '/admin/tipos-de-combustiveis',
        roles: ADMIN_ROLES,
      },
      {
        title: 'Coordenadores',
        icon: Users,
        path: '/admin/coordenadores',
        roles: ADMIN_ROLES,
      },
      {
        title: 'Gerentes',
        icon: UserCog,
        path: '/admin/gerentes',
        roles: ADMIN_ROLES,
      },
    ],
  },
];

export function getFilteredMenu(userRole) {
  if (!userRole) return [];
  
  // Normalizar role do usuário para comparação (case-insensitive)
  const normalizeRole = (role) => role?.toLowerCase();
  const normalizedUserRole = normalizeRole(userRole);
  
  const filterMenu = (items) => {
    return items
      .filter(item => {
        // Se o item tem roles definidas, verificar se o usuário tem uma delas
        if (item.roles && item.roles.length > 0) {
          const hasAccess = item.roles.some(role => 
            normalizeRole(role) === normalizedUserRole
          );
          if (!hasAccess) {
            return false;
          }
        }
        // Se tem filhos, filtrar os filhos também
        if (item.children) {
          const filteredChildren = filterMenu(item.children);
          if (filteredChildren.length === 0) {
            return false;
          }
          return true;
        }
        return true;
      })
      .map(item => {
        if (item.children) {
          return {
            ...item,
            children: filterMenu(item.children),
          };
        }
        return item;
      });
  };

  return filterMenu(MENU_SIDEBAR);
}

